import {ExtendedDataSettingModalState} from "../modal/ExtendedDataSettingModalState";

export async function initExtendedDataModal(rootStore, isView = false, isRemovedExtendedData = false) {
    let extendedDataStore = rootStore.domainStore.extendedDataStore;
    let extendedDataSetStore = rootStore.domainStore.extendedDataSetStore;

     extendedDataStore.init();
     extendedDataSetStore.init();

    const extendedDataSelectState = rootStore.rootUiStore.extendedDataSelectStore
    const extendedDataSetSelectState = rootStore.rootUiStore.extendedDataSetSelectStore
    const extendedDataSettingModalState = ExtendedDataSettingModalState.create({
        extendedDataSetSelectStore: extendedDataSetSelectState,
        extendedDataSelectStore: extendedDataSelectState,
        isView: isView,
        isRemovedExtendedData: isRemovedExtendedData
    });

    return extendedDataSettingModalState;
}

export function addExtendedDataToCode(state) {
    if (!state.extendedDataSettingModalState?.noExtendedDataSetOpen && state.extendedDataSettingModalState?.showDropdown) {
        const selectedExtendedData = state.extendedDataSettingModalState?.getSelectedExtendedDataMap() || {};
        const extendedDataList = Object.values(selectedExtendedData).map(item => item.uuid || item);
        state.extendedDataList = Object.values(selectedExtendedData);

        // If using with the batchType constants, handle edit batch type
        if (state.batchType === 'Edit') {
            state.extendedDataSettingModalState.isRemovedExtendedData = false;
        }
    } else if (state.extendedDataSettingModalState?.noExtendedDataSetOpen || !state.extendedDataSettingModalState?.showDropdown) {
        // Clear extended data
        state.extendedDataList = [];

        if (state.extendedDataSettingModalState?.noExtendedDataSetOpen) {
            state.extendedDataSettingModalState?.clearState();
        }

        if (state.batchType === 'Edit') {
            state.extendedDataSettingModalState.isRemovedExtendedData = true;
        }
    }
}
